var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPoundSign = function SvgPoundSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.604 10.82h4.632V8.107H4.604V6.56c0-1.809 1.122-2.927 2.817-2.927 1.433 0 2.436.761 2.722 2.094h3.176C12.96 2.752 10.692.872 7.42.872 3.864.872 1.476 3.11 1.476 6.56v1.547H.067v2.713h1.41v3.808H.066v2.713H13.01v-2.713H4.604z"
  })));
};
export { SvgPoundSign as ReactComponent };
export default __webpack_public_path__ + "images/pound-sign.svg";